export const availableCountries = ['PE', 'CO', 'CR', 'EC', 'MX']
